<template>
    <div class="predictor-teams">
        <div
            v-for="team in teams"
            :key="team.id"
            class="predictor-teams__item"
            @click="routeToTeamPredictions(team.id)"
        >
            <img
                v-if="team.logo && team.logo.length !== 0"
                :src="team.logo[0].url"
                class="predictor-teams__logo"
            >
            <img
                v-else
                src="@webapp/assets/socios-grey-placeholder.webp"
                class="predictor-teams__logo placeholder"
            >

            <p class="predictor-teams__name">{{ team.shortName }}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'matches-teams',
    props: {
        teams: {
            type: Array,
            required: true,
        },
    },
    methods: {
        routeToTeamPredictions(teamId) {
            this.$router.push(`/predictor/team/${teamId}`);
        },
    },
};
</script>

<style lang="scss" scoped>
.predictor-teams {
    display: flex;
    flex-wrap: wrap;
    background-color: $white-color;
    border-radius: 8px;
    padding: 1.4rem;

    @include max-width(xl) {
        > .predictor-teams__item:nth-child(n + 5) {
            margin-top: 1.4rem;
        }
    }

    @include max-width(lg) {
        > .predictor-teams__item:nth-child(n + 4) {
            margin-top: 1.4rem;
        }
    }

    @include min-width(xl) {
        gap: 2.7rem;
    }

    &__item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 33%;

        @include min-width(lg) {
            width: 25%;
        }

        @include min-width(xl) {
            width: auto;
        }
    }

    &__name {
        color: $daintree-color;
        font-family: "Nunito";
        font-size: 1.3rem;
        font-weight: 700;
        margin: 1.2rem 0 0;
    }

    &__logo {
        object-fit: contain;
        width: 60px;
        height: 60px;
        cursor: pointer;
    }

    .placeholder {
        border-radius: 100%;
        border-width: 0.5;
        border-color: $silver-color;
        background-color: $silver-color;
    }
}
</style>